import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
// core-js is a polyfill for various es6 and above features in IE11
// see : http://kangax.github.io/compat-table/es6/
// and: https://github.com/zloirock/core-js
import "core-js/stable"
import "regenerator-runtime/runtime"

import RootContainer from "components/containers/RootContainer"
import "css/main.scss"
import { initializeErrorReporting } from "utils/ErrorReporting"
import { lightFormTheme } from "themes/formThemes"

import configureStore from "configureStore"
import { ThemeProvider } from "styled-components"
import { BrowserRouter } from "react-router-dom"
import { ExtendedStringifyOptions, QueryParamProvider, transformSearchStringJsonSafe } from "use-query-params"
import { Route } from "react-router"
import { ConnectInsuranceContextProvider } from "./components/context/enrollment/ConnectInsuranceContext"
import SignUpFlowProvider from "components/context/signup/SignUpFlowContext"
import { CarrotThemeProvider, GlobalStyles } from "@carrotfertility/carotene"
initializeErrorReporting()

// this is referenced in the modal object TODO: move this to a config file
const applicationNode = "body"

const store = configureStore()

const queryStringifyOptions: ExtendedStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={lightFormTheme}>
        <QueryParamProvider ReactRouterRoute={Route} stringifyOptions={queryStringifyOptions}>
          <SignUpFlowProvider>
            <ConnectInsuranceContextProvider>
              <CarrotThemeProvider>
                <GlobalStyles />
                <RootContainer />
              </CarrotThemeProvider>
            </ConnectInsuranceContextProvider>
          </SignUpFlowProvider>
        </QueryParamProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById(applicationNode)
)
